import { Accordion, AccordionSummary, Box, Divider, Stack, Typography } from '@mui/material';
import type { DynamicInvoicePageRevisionedLineItem } from '@weft/api-definition';
import { REVISIONED_LINE_ITEM_TYPES, type Currency } from '@weft/types';
import React from 'react';
import { Price } from '../../../../../components/design/Price';
import { DynamicActionMenu } from './dynamic-invoice-line-Item-components/DynamicActionMenu';

type DynamicInvoiceRevisionedLineItemProps = {
  item: DynamicInvoicePageRevisionedLineItem;
  disabled?: boolean;
  onClick?: () => void;
  onDeleteClick: (id: string) => void;
  currency: Currency;
};

export const DynamicInvoiceRevisionedLineItem: React.FC<DynamicInvoiceRevisionedLineItemProps> = ({
  disabled = false,
  item,
  onClick,
  onDeleteClick,
  currency,
}) => {
  const isPromotion = item.type === REVISIONED_LINE_ITEM_TYPES.PercentagePromotion;

  return (
    <>
      <Accordion>
        <AccordionSummary>
          <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ width: '250px', paddingY: 4, flexDirection: 'column', gap: 1 }}>
              <Box
                display="flex"
                alignItems="center"
                gap={2}
              >
                <Typography
                  variant='subtitle1'
                  fontWeight={400}
                  fontSize="16px"
                >
                  {item.name}
                </Typography>
                {isPromotion && (
                  <Typography
                    color="text.secondary"
                    variant="body1"
                  >
                    {`(${item.percentage}%)`}
                  </Typography>
                )}
              </Box>
              <Typography
                variant='body2'
                color='rgba(27, 61, 85, 0.60)'
              >
                {item.description}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 10, flexGrow: 1, justifyContent: 'flex-end' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <Typography
                  variant="body2"
                  sx={{ color: 'rgba(27, 61, 85, 0.60)', textAlign: 'right' }}
                >
                  Amount
                </Typography>
                <Price
                  variant="h6"
                  currency={currency}
                >
                  {isPromotion ? -item.price : item.price}
                </Price>
              </Box>
            </Box>
            <Stack justifyContent="flex-end">
              <DynamicActionMenu
                itemId={item.id}
                disabled={disabled}
                onEdit={onClick}
                onDelete={onDeleteClick}
              />
            </Stack>        
          </Box>
        </AccordionSummary>
      </Accordion>
      <Divider />
    </>
  );
};